import { useEffect, useReducer } from "react";
import { subscribeByKey } from "./boards-event-bus";

/**
 * Forces a re-render of the consuming component when the given task record
 * is updated via the boards event bus.
 *
 * Replaces the previous pattern of:
 *   - window.addEventListener("task-updated", ...)
 *   - Filtering by taskId in the handler
 *   - Calling a useReducer-based forceUpdate
 *
 * Usage: useTaskUpdate(taskRecord)
 */
export function useTaskUpdate(taskRecord: { id: string | number }): void {
   const [, forceUpdate] = useReducer((x: number) => x + 1, 0);

   useEffect(() => {
      return subscribeByKey("task-updated", "taskId", String(taskRecord.id), forceUpdate);
   }, [taskRecord.id]);
}
